import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { DevicesStore, GatewayStore, InstallationFeaturesStore, RichDevice } from '@store';
import {
  Feature,
  FeatureNames,
  FrostProtectionCommands,
  FrostProtectionProperties,
  VentilationAutomatedModeLevelCommands,
  VentilationAutomatedModeLevelProperties,
  VentilationBypassModeCommands,
  VentilationBypassModeProperties,
  VentilationModeCommands,
  VentilationModeProperties,
  VentilationOperatingModesActivePrograms,
} from '@vi-iot/client/index';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-ventilation-overlay',
  templateUrl: './ventilation-overlay.component.html',
  styleUrls: ['./ventilation-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VentilationOverlayComponent implements OnInit, OnDestroy {
  isVentilationQuickSelectionsVisible$: Observable<boolean>;
  ventilationBypassMode$: Observable<
    Feature<VentilationBypassModeProperties, VentilationBypassModeCommands>
  >;
  ventilationMode$: Observable<Feature<VentilationModeProperties, VentilationModeCommands>>;
  ventilationAutomatedModeLevel$: Observable<
    Feature<VentilationAutomatedModeLevelProperties, VentilationAutomatedModeLevelCommands>
  >;
  VentilationOperatingModesActivePrograms = VentilationOperatingModesActivePrograms;

  remoteControllerDevices: RichDevice[];
  ventilationHeatExchangerType$: Observable<
    Feature<FrostProtectionProperties, FrostProtectionCommands>
  >;
  readonly featureNames = FeatureNames;

  private ngUnsubscribe$: Subject<void> = new Subject<void>();
  constructor(
    public devicesStore: DevicesStore,
    public installationFeaturesStore: InstallationFeaturesStore,
    public gatewayStore: GatewayStore
  ) {}

  ngOnInit(): void {
    this.isVentilationQuickSelectionsVisible$ = this.installationFeaturesStore.isVentilationQuickSelectionsVisible$;

    this.ventilationBypassMode$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.ventilationBypassMode
    );

    this.ventilationMode$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.ventilationMode
    );

    this.ventilationAutomatedModeLevel$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.ventilationAutomatedModeLevel
    );

    this.ventilationHeatExchangerType$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.ventilationHeatExchangerType
    );

    this.devicesStore.getRemoteControllerDevices$
      .pipe(takeUntil(this.ngUnsubscribe$))
      .subscribe((devices) => {
        this.remoteControllerDevices = devices;
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe$.next();
    this.ngUnsubscribe$.complete();
  }
}
